export const routes = [
  {
    path: '/cidade/:id/andamento',
    component: () => import(/* webpackChunkName: "task" */ './components/CityProgress'),
    name: 'task.city.progress',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/tarefas/andamento',
    component: () => import(/* webpackChunkName: "task" */ './components/city/ListTasksProgress'),
    name: 'task.progress',
    meta: {
      requiresAuth: true
    }
  }
]
